<template>
  <div class="mb-4">
    <b-input-group prepend="Servicios" class="grupoComboModuloOferta">
      <div class="combo-modulos">
        <select-box v-model="value" :url="endpointServicios" :disabled="disabled" />
      </div>
      <b-input-group-append>
        <b-button
          variant="primary"
          @click="moduloSeleccionado"
          title="Añadir servicio"
          class="buttonAddModulo"
          :disabled="disabled"
        >
          <v-icon name="plus" width="17" style="margin-top: 2px" />
          <span class="align-middle ml-1">Agregar</span>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <div class="clearfix" />
  </div>
</template>
<script>
import { mapActions, mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: mapState(useOfertaFormStore, ["endpointServicios"]),
  data() {
    return {
      value: null,
    };
  },
  methods: {
    ...mapActions(useOfertaFormStore, ["agregarModulo"]),
    moduloSeleccionado() {
      this.agregarModulo(this.value);
      this.value = null;
    },
  },
};
</script>
